@if (emailTemplates$ | async; as emailTemplates) {
    <form #templatesForm="ngForm">
        @for (template of emailTemplates; track template.emailType) {
            <div data-qa="email-template">
                <h4 style="background-color:lightgrey; padding:3px;"
                    data-qa="headline">{{ getHeadlineFor(template.emailType) }}</h4>
                <div class="container">
                    <div class="left-column">
                        <div class="formfield-section">
                            <mat-form-field>
                                <mat-label>Betreff (Kein HTML)</mat-label>
                                <input matInput
                                       data-qa="subject-input-field"
                                       [(ngModel)]="template.subject"
                                       id="template_subject_{{template.emailType}}"
                                       name="template_subject_{{template.emailType}}"/>
                            </mat-form-field>
                            <!-- this makes the dynamic template engine useless but even with hours of discussions, they wanted it...-->
                            @if (template.emailType === 'CONTACT_DATA_UPDATE') {
                                <mat-form-field>
                                    <mat-label>CC-Email Adressen, mit Komma getrennt</mat-label>
                                    <input matInput [tnbValidEmailList]=""
                                           [(ngModel)]="template.ccReceiverAddresses"
                                           #emailAdressen="ngModel"
                                           data-qa="ccReceiverAddresses-input-field"
                                           id="template_subject_{{template.ccReceiverAddresses}}"
                                           name="template_subject_{{template.ccReceiverAddresses}}"
                                           required
                                    />
                                    @if (emailAdressen?.errors?.validEmailList) {
                                        <mat-error>
                                            Die Emailadressen müssen gültig sein.
                                        </mat-error>
                                    }
                                </mat-form-field>
                            }
                            <mat-form-field>
                                <mat-label>Inhalt (HTML)</mat-label>
                                <textarea
                                    matInput
                                    rows="15"
                                    maxlength="2048"
                                    data-qa="body-input-field"
                                    [(ngModel)]="template.body"
                                    id="template_body_{{template.emailType}}"
                                    name="template_body_{{template.emailType}}">
              </textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="right-column">
                        <div class="receiver-info-section" data-qa="receiver-info-section">
                            <h4 data-qa="placeholder-headline">Empfänger-Bestimmung</h4>
                            @if (template.emailType === 'DATA_CONFIRMATION_OVERDUE') {
                                Job Quartz-Job (0 0 */1 * * ?) sendet jedem Netzbetreiber für den gilt:
                                    erzeugungsAnlagenPflegeAktiv = Ja &&
                                    lastChangedLower < (Ausführungszeitpunkt - 30 Tage) && lastChangedNotificationSend <
                                    (Ausführungszeitpunkt - 30 Tage)
                                    eine Erinnerungs-Email an bis zu vier Postfächer die er selber bei seinen Informationen
                                    informatorischen Kaskade angegeben hat.
                            }
                            @if (template.emailType === 'DATENABFRAGE_OVERDUE') {
                                Sendet jedem Netzbetreiber für den gilt:
                                    datenAbfrageAktiv && kein AktiverAufteilungsschluessel vorhanden
                                    eine Erinnerungs-Email an bis zu vier Postfächer die er selber bei seinen Informationen
                                    informatorischen Kaskade angegeben hat.
                            }
                            @if (template.emailType === 'CONTACT_DATA_UPDATE') {
                                Sobald ein Netzbetreiber seine Kontaktdaten ändert wird an die Email-Postfächer der ihm
                                    zugewiesenen Schaltleitung(en)
                                    eine E-Mail versendet. Die CC-Empfänger dieser Mails kann links gepflegt werden.
                            }
                        </div>
                        <div class="placeholder-section" data-qa="placeholder-section">
                            <h4 data-qa="placeholder-headline">Platzhalter</h4>
                            <ng-container>
                                <div data-qa="placeholder">#NETZBETREIBER_NAME</div>
                                <div class="description" data-qa="placeholder-description">Der Name des angeschriebenen
                                    Netzbetreibers
                                </div>
                            </ng-container>
                            <ng-container>
                                <div data-qa="placeholder">#NETZBETREIBER_TEILGEBIET</div>
                                <div class="description" data-qa="placeholder-description">Das Teilgebiet des
                                    angeschriebenen
                                    Netzbetreibers
                                </div>
                            </ng-container>
                            <ng-container>
                                <div data-qa="placeholder">#NETZBETREIBER_PGON</div>
                                <div class="description" data-qa="placeholder-description">Die PGON des angeschriebenen
                                    Netzbetreibers
                                </div>
                            </ng-container>
                            <ng-container>
                                <div data-qa="placeholder">#NETZBETREIBER_STADTWERKE_ID</div>
                                <div class="description" data-qa="placeholder-description">Der Stadtwerke-ID des
                                    angeschriebenen
                                    Netzbetreibers
                                </div>
                            </ng-container>
                            @if (template.emailType !== 'CONTACT_DATA_UPDATE') {
                                <div data-qa="placeholder">#NETZBETREIBER_LASTUPDATED</div>
                                <div class="description" data-qa="placeholder-description">Der Zeitpunkt der letzten
                                    Aktualisierung
                                    des Netzbetreibers
                                </div>
                            }
                            @if (template.emailType === 'DATENABFRAGE_OVERDUE') {
                                <div data-qa="placeholder">#DATENABFRAGE_BEZEICHNUNG</div>
                                <div class="description" data-qa="placeholder-description">Die Bezeichnung/Name der
                                    Datenabfrage
                                </div>
                            }
                            @if (template.emailType === 'DATENABFRAGE_OVERDUE') {
                                <div data-qa="placeholder">#DATENABFRAGE_ABGABEFRIST</div>
                                <div class="description" data-qa="placeholder-description">Das formatierte Datum der
                                    Abgabefrist
                                    der
                                    Datenabfrage
                                </div>
                            }
                            @if (template.emailType === 'DATENABFRAGE_OVERDUE') {
                                <div data-qa="placeholder">#DATENABFRAGE_REFZEITRAUM_ENDVERBRAUCHERLAST</div>
                                <div class="description" data-qa="placeholder-description">Der Referenzzeitraum der
                                    Endverbraucherlast
                                </div>
                            }
                            @if (template.emailType === 'DATENABFRAGE_OVERDUE') {
                                <div data-qa="placeholder">#DATENABFRAGE_REFZEITRAUM_ERZEUGERLEISTUNG</div>
                                <div class="description" data-qa="placeholder-description">Der Referenzzeitraum der
                                    Erzeugerleistung
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div style="clear:both"></div>
            </div>
        }
    </form>
    <div class="buttons">
        <button matButton="filled"
                type="button"
                (click)="saveAllEmailTemplates(emailTemplates)" [disabled]="templatesForm.invalid"
                data-qa="save-templates">
            <mat-icon>save</mat-icon>
            Templates speichern
        </button>
        <button matButton="outlined"
                type="button"
                (click)="sendTestEmails()" data-qa="send-testmails">
            <mat-icon svgIcon="innogy_picto_envelope_at"></mat-icon>
            Test-Emails senden
        </button>
    </div>
}
